import { API_CONFIG, buildApiUrl, getAuthHeaders } from '../config/api.ts';
import { apiRequest } from '../utils/apiRequest.ts';

export interface MiscPurchase {
  id: number;
  itemName: string;
  date: string;
  value: number;
  purchaserName: string;
  amountTakenFrom: string;
  cashAmount: number;
  reasonForPurchase: string;
  userId: number;
  createdDate: number;
}

export interface CreateMiscPurchaseRequest {
  itemName: string;
  date?: string;
  value: number;
  purchaserName: string;
  amountTakenFrom: string;
  cashAmount: number;
  reasonForPurchase: string;
}

export interface PaginatedMiscPurchasesResponse {
  data: MiscPurchase[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  hasNext: boolean;
  hasPrev: boolean;
}

export const miscPurchasesApi = {
  getAll: (params: { page?: number; limit?: number }, token: string): Promise<PaginatedMiscPurchasesResponse> => {
    const q = new URLSearchParams();
    if (params.page) q.append('page', params.page.toString());
    if (params.limit) q.append('limit', params.limit.toString());
    return apiRequest<PaginatedMiscPurchasesResponse>(
      `${buildApiUrl(API_CONFIG.ENDPOINTS.MISC_PURCHASES.BASE)}?${q}`,
      { method: 'GET', headers: getAuthHeaders(token) }
    );
  },

  create: (data: CreateMiscPurchaseRequest, token: string): Promise<MiscPurchase> =>
    apiRequest<MiscPurchase>(buildApiUrl(API_CONFIG.ENDPOINTS.MISC_PURCHASES.BASE), {
      method: 'POST',
      headers: getAuthHeaders(token),
      body: JSON.stringify(data),
    }),

  update: (id: number, data: Partial<CreateMiscPurchaseRequest>, token: string): Promise<MiscPurchase> =>
    apiRequest<MiscPurchase>(buildApiUrl(API_CONFIG.ENDPOINTS.MISC_PURCHASES.BY_ID(id)), {
      method: 'PUT',
      headers: getAuthHeaders(token),
      body: JSON.stringify(data),
    }),

  remove: (id: number, token: string): Promise<void> =>
    apiRequest<void>(buildApiUrl(API_CONFIG.ENDPOINTS.MISC_PURCHASES.BY_ID(id)), {
      method: 'DELETE',
      headers: getAuthHeaders(token),
    }),
};
